import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import aboutimg from "../../../assets/images/aboutimg.png"
import { BuyNow } from "../S1_Header/styles";
import { useTheme } from "@emotion/react";

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "700px")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const FeatureWrapper = styled.div`
 background: #151515;
  text-align:center;
border-radius:20px;
  padding: 20px;
  height:440px;
  
  @media screen and (max-width:499px){
  height: 550px;

 }
`
const Wrap = styled.div`

background-size: cover;
background-repeat: no-repeat;
background-position:center;
    min-height: 506px;
    display: flex;
    align-items: center;
    padding:40px 30px;
    border-radius:30px;
    @media screen and (max-width:499px){
/* margin:0 0 0 20px; */

 }

`
const S2_Aboutus = () => {
  const theme = useTheme()
  return (
    <div>
      <SectionWrapper bgColor="#001524" p="2rem 0 0" p799="0" p599="0" id="About">
        <Container maxWidth="xl">

          <GridHEading container columnSpacing={2} rowSpacing={3}>
            <GridImage item xs={12} md={6}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectionHeading
                fs="70px"
                p="30px 0"
                m="0"
                align="left"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >About
              </SectionHeading>


              <P align="LEFT"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
              Welcome to PULSE OTC, the go-to platform for swapping Ethereum for $Pulse on the Pulse network! We understand that finding reliable outlets for buying and selling cryptocurrency can be a challenge, which is why we have created a simple and secure platform that allows you to easily swap out Ethereum for $Pulse.
<br/>
<br/>
Our team at PULSE OTC is dedicated to providing you with a safe and hassle-free experience. We have implemented top-notch security measures to ensure that your transactions are always protected. Additionally, our user-friendly interface makes it easy for you to navigate our platform and complete your transactions quickly.
<br/>
<br/>

Whether you're an experienced trader or just starting out in the world of cryptocurrency, PULSE OTC is the perfect platform for you. Our platform is designed to provide you with all the tools and resources you need to make informed decisions about your trades. From real-time market data to comprehensive analytics, we have everything you need to stay ahead of the game.
<br/>
<br/>

So why wait? Sign up for PULSE OTC today and start swapping Ethereum for $Pulse on the Pulse network. With our reliable platform and user-friendly interface, you can easily buy and sell cryptocurrency with confidence. </P>
              <BuyNow >OTC TG Group</BuyNow>



            </GridImage>
            <GridImage item xs={12} md={6} data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="200"
              data-aos-duration="500"
              data-aos-offset="0">

              <JOiningLinks src={aboutimg} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0" />
            

            </GridImage>
          </GridHEading>

        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
